var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitSearch('form-1')
      }
    }
  }, [_c('legend', [_vm._v("Confirm Connection Schedule")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('form-1.HubName')
    },
    attrs: {
      "options": _vm.HubNameData,
      "name": "HubName",
      "label": "text",
      "track-by": "value",
      "placeholder": "Select Hub",
      "show-labels": false,
      "multiple": false,
      "max-height": 300,
      "clearable": false
    },
    on: {
      "select": _vm.selectedHub
    },
    model: {
      value: (_vm.srcHubName),
      callback: function($$v) {
        _vm.srcHubName = $$v
      },
      expression: "srcHubName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.HubName')),
      expression: "errors.has('form-1.HubName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.HubName')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Status")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Status),
      expression: "Status"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.errors.has('form-1.Status')
    },
    attrs: {
      "name": "Status",
      "id": "Status"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeStatus]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pending"
    }
  }, [_vm._v("Pending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ConfirmeD"
    }
  }, [_vm._v("Confirmed")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Status')),
      expression: "errors.has('form-1.Status')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.Status')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Route Mode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RouteMode),
      expression: "RouteMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('form-1.RouteMode')
    },
    attrs: {
      "name": "RouteMode",
      "id": "RouteMode"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.RouteMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getColoder()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Route Mode")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "surface"
    }
  }, [_vm._v("Surface")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "air"
    }
  }, [_vm._v("Air")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "train"
    }
  }, [_vm._v("Train")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.RouteMode')),
      expression: "errors.has('form-1.RouteMode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.RouteMode')))])], 1)], 1), _vm._v(" "), (_vm.Show) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Connections")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-signs'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('form-1.srcConnectionName')
    },
    attrs: {
      "options": _vm.srcConnectionNameData,
      "selected-option": _vm.srcConnectionObjData,
      "name": "srcConnectionName",
      "placeholder": "Select Connection",
      "id": "conection"
    },
    on: {
      "select": _vm.selectedConnection
    },
    model: {
      value: (_vm.srcConnectionName),
      callback: function($$v) {
        _vm.srcConnectionName = $$v
      },
      expression: "srcConnectionName"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isConnectionError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ConnectionError))]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.srcConnectionName')),
      expression: "errors.has('form-1.srcConnectionName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.srcConnectionName')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.connectionLoading))])], 1) : _vm._e(), _vm._v(" "), (_vm.Show) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" Coloader")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker'></i>",
      "right": _vm.coright
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.coloaderlist,
      "selected-option": _vm.coloaderitem,
      "placeholder": "Select Coloader",
      "name": "coloadername"
    },
    on: {
      "select": _vm.SelectColoader
    },
    model: {
      value: (_vm.confirmLHC.coloadername),
      callback: function($$v) {
        _vm.$set(_vm.confirmLHC, "coloadername", $$v)
      },
      expression: "confirmLHC.coloadername"
    }
  })], 1), _vm._v(" "), (_vm.isColoaderError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ColoaderError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('form-1.FromDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "DD-MM-YYYY",
      "name": "FromDate"
    },
    model: {
      value: (_vm.FromDate),
      callback: function($$v) {
        _vm.FromDate = $$v
      },
      expression: "FromDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.FromDate')),
      expression: "errors.has('form-1.FromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.FromDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('form-1.ToDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "DD-MM-YYYY",
      "name": "ToDate",
      "not-before": _vm.FromDate
    },
    model: {
      value: (_vm.ToDate),
      callback: function($$v) {
        _vm.ToDate = $$v
      },
      expression: "ToDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ToDate')),
      expression: "errors.has('form-1.ToDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.ToDate')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.getConnectionSchedule()
      }
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        return _vm.resetSearchForm()
      }
    }
  }, [_vm._v("Reset")])])])])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.displayConnectionSchedule) ? _c('fieldset', [_c('legend', [_vm._v("Scheduled Connection Bags/Shipments")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "auto"
    }
  }, [_c('span', {
    staticClass: "float-right",
    staticStyle: {
      "color": "#20a8d8"
    }
  }, [_vm._v("Total Record :"), _c('span', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "lass": "float-right"
    }
  }, [_vm._v(_vm._s(_vm.LineHaulDetailsLstAll.length))])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Invoice No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Coloader Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Line Haul Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Total Bags")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Total LineHaul Bags")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Edit")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.LineHaulDetailsLstAll), function(data, index) {
    return (_vm.LineHaulDetailsLstAll.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.invoiceno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.coloadername))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.linehaulstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalbags))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totallinehaulbags))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.showBagDetails(data)
        }
      }
    }, [_vm._v(" Edit Connection Schedule ")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.LineHaulDetailsLstAll.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 10),
      expression: "totalRows>10"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.confirmedConnectionSchedule) ? _c('fieldset', [_c('legend', [_vm._v("Confirmed Connection Schedule")]), _vm._v(" "), _c('b-card', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Coloader Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("LineHaul Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Show")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Print")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.confirmedConnectionScheduleData), function(data, index) {
    return (_vm.confirmedConnectionScheduleData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.coloadername))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.linehaulstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.showConnectionDetails(data)
        }
      }
    }, [_vm._v("Show Connection Details")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.printLineHaulConnection(data)
        }
      }
    }, [_vm._v("Print Line Haul Details")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.confirmedConnectionScheduleData.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])])], 1) : _vm._e(), _vm._v(" "), (_vm.lineHaulBagDetails) ? _c('fieldset', [_c('legend', [_vm._v("Line Haul Bag Details")]), _vm._v(" "), _c('b-card', [_c('form', {
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitSelectConnection.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "auto"
    }
  }, [_c('span', {
    staticClass: "float-right",
    staticStyle: {
      "color": "#20a8d8"
    }
  }, [_vm._v("Total Bags :"), _c('span', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "lass": "float-right"
    }
  }, [_vm._v(_vm._s(_vm.LineHaulDetailsBag.length))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.bagno')),
      expression: "errors.has('form-2.bagno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select bag")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sAll),
      expression: "sAll"
    }],
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.sAll) ? _vm._i(_vm.sAll, "") > -1 : (_vm.sAll)
    },
    on: {
      "click": _vm.selectAll,
      "change": function($event) {
        var $$a = _vm.sAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sAll = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Subtype")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("LineHaul Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vol.Wt.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Phys.Wt.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.LineHaulDetailsBag), function(data, index) {
    return (_vm.LineHaulDetailsBag.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedBags),
        expression: "selectedBags"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required:true}"
      }],
      class: {
        'error': _vm.errors.has('form-2.bagno')
      },
      staticStyle: {
        "font-size": "0.8em"
      },
      attrs: {
        "type": "checkbox",
        "name": "bagno",
        "id": data.connectionscheduleid
      },
      domProps: {
        "value": {
          connectionscheduleid: data.connectionscheduleid,
          bagno: data.bagno
        },
        "checked": Array.isArray(_vm.selectedBags) ? _vm._i(_vm.selectedBags, {
          connectionscheduleid: data.connectionscheduleid,
          bagno: data.bagno
        }) > -1 : (_vm.selectedBags)
      },
      on: {
        "click": _vm.selectedBagsData,
        "change": function($event) {
          var $$a = _vm.selectedBags,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = {
                connectionscheduleid: data.connectionscheduleid,
                bagno: data.bagno
              },
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedBags = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedBags = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedBags = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentbagsubtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.linehaulstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.cscreateddate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.LineHaulDetailsBag.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select Action")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.connectionType),
      expression: "connectionType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('form-2.Action')
    },
    attrs: {
      "name": "Action",
      "id": "connectionType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.connectionType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Action")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ConfirmConnection"
    }
  }, [_vm._v("Confirm Connection")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OffloadConnection"
    }
  }, [_vm._v("Partial Offload Connection")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RescheduleConnection"
    }
  }, [_vm._v("Complete Offload Connection")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.Action')),
      expression: "errors.has('form-2.Action')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-2.Action')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.changeConnection()
      }
    }
  }, [_vm._v("Go")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        return _vm.resetChangeConnectionForm()
      }
    }
  }, [_vm._v("Reset")])])])])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('fieldset', [(_vm.ConfirmConnection) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-3"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitConfirmConnection.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Confirm Connection Schedule")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Coloader Name:")]), _vm._v(" "), _c('span', {
    staticClass: "col-lg-6",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.coloadername))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Route Mode:")]), _vm._v(" "), _c('span', {
    staticClass: "col-lg-6",
    staticStyle: {
      "margin-left": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("jsUcfirst")(_vm.RouteMode)) + " "), (_vm.linehaulstatus != '') ? _c('span', [_vm._v("(" + _vm._s(_vm._f("jsUcfirst")(_vm.linehaulstatus)) + ")")]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.showSurfaceFields == true) ? _c('label', [_vm._v("Vehicle Name"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]) : _vm._e(), _vm._v(" "), (_vm.showTrainFields == true) ? _c('label', [_vm._v("Train Name"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]) : _vm._e(), _vm._v(" "), (_vm.showFlightFields == true) ? _c('label', [_vm._v("Flight Name"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]) : _vm._e(), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('form-3.vehicleNo')
    },
    attrs: {
      "options": _vm.vehicleNameData,
      "selected-option": _vm.vehicleDataObj,
      "name": "vehicleNo",
      "placeholder": "Select Vehicle"
    },
    on: {
      "select": _vm.selectVehicle
    },
    model: {
      value: (_vm.vehicleNo),
      callback: function($$v) {
        _vm.vehicleNo = $$v
      },
      expression: "vehicleNo"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.vehicleNo')),
      expression: "errors.has('form-3.vehicleNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-3.vehicleNo')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.vehicleLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("AWB No"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWBNo),
      expression: "AWBNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-3.AWBNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter AWB No",
      "name": "AWBNo",
      "id": "AWBNo"
    },
    domProps: {
      "value": (_vm.AWBNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWBNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.AWBNo')),
      expression: "errors.has('form-3.AWBNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-3.AWBNo')))])], 1)], 1), _vm._v(" "), (_vm.HideDiv == true) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("XB LH. Phy. Wt.")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.xblhphywt),
      expression: "xblhphywt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-3.xblhphywt')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter XB LH. Phy. Wt.",
      "name": "xblhphywt",
      "id": "xblhphywt"
    },
    domProps: {
      "value": (_vm.xblhphywt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.xblhphywt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.xblhphywt')),
      expression: "errors.has('form-3.xblhphywt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-3.xblhphywt')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.HideDiv == true) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("XB LH. Vol. Wt.")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.xblhvolwt),
      expression: "xblhvolwt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-3.xblhvolwt')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter XB LH. Vol. Wt.",
      "name": "xblhvolwt",
      "id": "xblhvolwt"
    },
    domProps: {
      "value": (_vm.xblhvolwt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.xblhvolwt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.xblhvolwt')),
      expression: "errors.has('form-3.xblhvolwt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-3.xblhvolwt')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Total Coloader Phy. Wt.")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.totalColoaderPhyWt),
      expression: "totalColoaderPhyWt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-3.totalColoaderPhyWt')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Total Coloader Phy. Wt.",
      "name": "totalColoaderPhyWt",
      "id": "totalColoaderPhyWt"
    },
    domProps: {
      "value": (_vm.totalColoaderPhyWt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalColoaderPhyWt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.totalColoaderPhyWt')),
      expression: "errors.has('form-3.totalColoaderPhyWt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-3.totalColoaderPhyWt')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Total Coloader Vol. Wt.")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.totalColoaderVolWt),
      expression: "totalColoaderVolWt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-3.totalColoaderVolWt')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Total Coloader Vol. Wt.",
      "name": "totalColoaderVolWt",
      "id": "totalColoaderVolWt"
    },
    domProps: {
      "value": (_vm.totalColoaderVolWt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalColoaderVolWt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.totalColoaderVolWt')),
      expression: "errors.has('form-3.totalColoaderVolWt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-3.totalColoaderVolWt')))])], 1)], 1)]), _vm._v(" "), (_vm.showTrainFields == true) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Boggie No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boggieNo),
      expression: "boggieNo"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Boggie No",
      "name": "boggieNo",
      "id": "boggieNo"
    },
    domProps: {
      "value": (_vm.boggieNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.boggieNo = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Break No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.breakNo),
      expression: "breakNo"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Break No",
      "name": "breakNo",
      "id": "breakNo"
    },
    domProps: {
      "value": (_vm.breakNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.breakNo = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Train Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trainType),
      expression: "trainType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.errors.has('form-3.trainType')
    },
    attrs: {
      "name": "trainType",
      "id": "trainType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trainType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Vehicle No")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Lease"
    }
  }, [_vm._v("Lease")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RR"
    }
  }, [_vm._v("RR")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.trainType')),
      expression: "errors.has('form-3.trainType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-3.trainType')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("PR No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rrNo),
      expression: "rrNo"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter PR No",
      "name": "rrNo",
      "id": "rrNo"
    },
    domProps: {
      "value": (_vm.rrNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rrNo = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("First PR No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstRRNo),
      expression: "firstRRNo"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter First PR No",
      "name": "firstRRNo",
      "id": "firstRRNo"
    },
    domProps: {
      "value": (_vm.firstRRNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstRRNo = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Second PR No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondRRNo),
      expression: "secondRRNo"
    }],
    class: {
      'form-control': true,
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Second PR No",
      "name": "secondRRNo",
      "id": "secondRRNo"
    },
    domProps: {
      "value": (_vm.secondRRNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secondRRNo = $event.target.value
      }
    }
  })])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("PC's(Total Bags)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pcTotalBag),
      expression: "pcTotalBag"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-3.pcTotalBag')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter PC's(Total Bags)",
      "name": "pcTotalBag",
      "id": "pcTotalBag",
      "disabled": _vm.isDisable == 1
    },
    domProps: {
      "value": (_vm.pcTotalBag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pcTotalBag = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Departure Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('form-3.departureDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "DD-MM-YYYY",
      "name": "departureDate",
      "disabled": _vm.isDisable == 1
    },
    model: {
      value: (_vm.departureDate),
      callback: function($$v) {
        _vm.departureDate = $$v
      },
      expression: "departureDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.departureDate')),
      expression: "errors.has('form-3.departureDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-3.departureDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Departure Time")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-clock-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.departureTime),
      expression: "departureTime"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-3.departureTime')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Departure Time",
      "name": "departureTime",
      "id": "departureTime",
      "disabled": _vm.isDisable == 1
    },
    domProps: {
      "value": (_vm.departureTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.departureTime = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.departureTime')),
      expression: "errors.has('form-3.departureTime')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-3.departureTime')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Schedule Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('form-3.scheduleDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "DD-MM-YYYY",
      "name": "scheduleDate",
      "disabled": _vm.isDisable == 1
    },
    model: {
      value: (_vm.scheduleDate),
      callback: function($$v) {
        _vm.scheduleDate = $$v
      },
      expression: "scheduleDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.scheduleDate')),
      expression: "errors.has('form-3.scheduleDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-3.scheduleDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Arrival Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('form-3.arrivalDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "DD-MM-YYYY",
      "name": "arrivalDate",
      "disabled": _vm.isDisable == 1
    },
    model: {
      value: (_vm.arrivalDate),
      callback: function($$v) {
        _vm.arrivalDate = $$v
      },
      expression: "arrivalDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.arrivalDate')),
      expression: "errors.has('form-3.arrivalDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-3.arrivalDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Arrival Time")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-clock-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.arrivalTime),
      expression: "arrivalTime"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-3.arrivalTime')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Arrival Time",
      "name": "arrivalTime",
      "id": "arrivalTime",
      "disabled": _vm.isDisable == 1
    },
    domProps: {
      "value": (_vm.arrivalTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.arrivalTime = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em",
      "margin-top": "32px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm),
      expression: "confirm"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-3.confirm')
    },
    attrs: {
      "type": "checkbox",
      "id": "confirm",
      "value": "confirm",
      "name": "confirm"
    },
    domProps: {
      "checked": Array.isArray(_vm.confirm) ? _vm._i(_vm.confirm, "confirm") > -1 : (_vm.confirm)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.confirm,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "confirm",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.confirm = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.confirm = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.confirm = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "confirm "
    }
  }, [_vm._v("Confirm Connection ")]), _vm._v(" "), _c('br'), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.confirm')),
      expression: "errors.has('form-3.confirm')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-3.confirm')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [(_vm.updateConnection == false) ? _c('button', {
    staticClass: "common-success-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.connectionConfirm()
      }
    }
  }, [_vm._v("Confirm Connection")]) : _vm._e(), _vm._v(" "), (_vm.updateConnection == true) ? _c('button', {
    staticClass: "common-success-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.connectionUpdate()
      }
    }
  }, [_vm._v("Update Connection")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "common-btn",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm()
      }
    }
  }, [_vm._v("Reset")])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.OffloadConnection) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-4"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitOffloadConnection.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Partial Offload Connection")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Offload Reason")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partialOffloadReason),
      expression: "partialOffloadReason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('form-4.partialOffloadReason')
    },
    attrs: {
      "name": "partialOffloadReason",
      "id": "partialOffloadReason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.partialOffloadReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _vm._l((_vm.offloadReasonData), function(offloadReason_obj) {
    return _c('option', {
      domProps: {
        "value": {
          offloadreasonmasterid: offloadReason_obj.offloadreasonmasterid,
          offloadstatuscode: offloadReason_obj.offloadstatuscode,
          offloadreasontype: offloadReason_obj.offloadreasontype,
          offloadreason: offloadReason_obj.offloadreason
        }
      }
    }, [_vm._v(_vm._s(offloadReason_obj.offloadreason))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-4.partialOffloadReason')),
      expression: "errors.has('form-4.partialOffloadReason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Offload Reason field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em",
      "margin-top": "32px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partialOffloadcheck),
      expression: "partialOffloadcheck"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-4.partialOffloadcheck')
    },
    attrs: {
      "type": "checkbox",
      "id": "partialOffloadcheck",
      "value": "OffloadConnection",
      "name": "partialOffloadcheck"
    },
    domProps: {
      "checked": Array.isArray(_vm.partialOffloadcheck) ? _vm._i(_vm.partialOffloadcheck, "OffloadConnection") > -1 : (_vm.partialOffloadcheck)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.partialOffloadcheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "OffloadConnection",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.partialOffloadcheck = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.partialOffloadcheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.partialOffloadcheck = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "partialOffloadcheck "
    }
  }, [_vm._v("Confirm Offload ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-4.partialOffloadcheck')),
      expression: "errors.has('form-4.partialOffloadcheck')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-4.partialOffloadcheck')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "-common-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.partialOffload()
      }
    }
  }, [_vm._v("Offload Bags")])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.RescheduleConnection) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-5"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitRescheduleConnection.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Complete Offload Connection")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Offload Reason")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.completeOffloadReason),
      expression: "completeOffloadReason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('form-5.completeOffloadReason')
    },
    attrs: {
      "name": "completeOffloadReason",
      "id": "completeOffloadReason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.completeOffloadReason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _vm._l((_vm.offloadReasonData), function(offloadReason_obj) {
    return _c('option', {
      domProps: {
        "value": {
          offloadreasonmasterid: offloadReason_obj.offloadreasonmasterid,
          offloadstatuscode: offloadReason_obj.offloadstatuscode,
          offloadreasontype: offloadReason_obj.offloadreasontype,
          offloadreason: offloadReason_obj.offloadreason
        }
      }
    }, [_vm._v(_vm._s(offloadReason_obj.offloadreason))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-5.completeOffloadReason')),
      expression: "errors.has('form-5.completeOffloadReason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-5.completeOffloadReason')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em",
      "margin-top": "32px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.completeOffloadcheck),
      expression: "completeOffloadcheck"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('form-5.completeOffloadcheck')
    },
    attrs: {
      "type": "checkbox",
      "id": "completeOffloadcheck",
      "value": "RescheduleConnection",
      "name": "completeOffloadcheck"
    },
    domProps: {
      "checked": Array.isArray(_vm.completeOffloadcheck) ? _vm._i(_vm.completeOffloadcheck, "RescheduleConnection") > -1 : (_vm.completeOffloadcheck)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.completeOffloadcheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "RescheduleConnection",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.completeOffloadcheck = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.completeOffloadcheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.completeOffloadcheck = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "completeOffloadcheck "
    }
  }, [_vm._v("Confirm Offload ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-5.completeOffloadcheck')),
      expression: "errors.has('form-5.completeOffloadcheck')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-5.completeOffloadcheck')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "-common-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.completeOffload()
      }
    }
  }, [_vm._v("Offload Bags")])])])])], 1)]) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbc288f2","hasScoped":true}!./src/views/components/ConfirmLineHaulConnection/ConfirmLineHaulConnection.html
// module id = 885
// module chunks = 2